import React from 'react'

export const IcoUpload = ({style={}}) => {
  return (
    <svg className='icon-upload' viewBox="0 0 12 13" style={style}>
      <path d="M1.25 9V10.25C1.25 10.5815 1.3817 10.8995 1.61612 11.1339C1.85054 11.3683 2.16848 11.5 2.5 11.5H10C10.3315 11.5 10.6495 11.3683 10.8839 11.1339C11.1183 10.8995 11.25 10.5815 11.25 10.25V9M3.75 4L6.25 1.5M6.25 1.5L8.75 4M6.25 1.5V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
